import styled from 'styled-components';
import { Hero } from '../sections/Hero';
import { AppShowcase } from '../sections/AppShowcase';
import { ProductivitySuite } from '../sections/ProductivitySuite';
import { CTASection } from '../sections/CTASection';
import { Section, SectionHeader } from '../ui/Section';
import { lifestyleApps, developerApps } from '../../data/apps';
import { PageHead } from '../seo';

const PageWrapper = styled.div`
  padding-top: 73px;
`;

const CategoryDescription = styled.p`
  text-align: center;
  max-width: 600px;
  margin: 0 auto var(--space-8);
  color: var(--color-text-secondary);
  font-size: var(--text-lg);
`;

export function Products() {
  return (
    <PageWrapper>
      <PageHead
        title="Our Apps"
        description="Explore our ecosystem of apps — productivity tools, lifestyle apps, and developer utilities built with React, TypeScript, Swift, and Firebase."
      />
      <Hero
        eyebrow="Our Products"
        title={
          <>
            Apps Designed for{' '}
            <span className="gradient">Real Life</span>
          </>
        }
        subtitle="Every app in our ecosystem is built with purpose - solving real problems with elegant, intuitive design. Whether you're planning meals, organizing your home, or coordinating with friends, we've got you covered."
        primaryCTA={{ label: 'Contact Us', to: '/contact' }}
        secondaryCTA={{ label: 'View Portfolio', to: '/portfolio' }}
        showStats={false}
      />

      {/* Productivity Suite - The W-Series */}
      <ProductivitySuite />

      {/* Lifestyle Apps */}
      <Section>
        <SectionHeader
          title="Lifestyle"
          subtitle="Apps for everyday living"
          centered
        />
        <CategoryDescription>
          From meal planning to puzzle games, these apps make daily life a little more enjoyable.
        </CategoryDescription>
        <AppShowcase apps={lifestyleApps} showHeader={false} showViewAll={false} />
      </Section>

      {/* Developer Tools */}
      <Section background="secondary">
        <SectionHeader
          title="Developer Tools"
          subtitle="For builders and makers"
          centered
        />
        <CategoryDescription>
          Tools we've built to enhance our own development workflow, now available for other developers.
        </CategoryDescription>
        <AppShowcase apps={developerApps} showHeader={false} showViewAll={false} />
      </Section>

      <CTASection
        title="Have an App Idea?"
        subtitle="We build custom apps too. Let's discuss your vision and bring it to life."
        primaryCTA={{ label: 'Start a Conversation', to: '/contact' }}
        secondaryCTA={{ label: 'Our Services', to: '/services' }}
      />
    </PageWrapper>
  );
}
